const ArrowDown = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 16L0 8L1.4 6.575L7 12.175V0H9V12.175L14.6 6.575L16 8L8 16Z" fill="white"/>
    </svg>
  )
}

export default ArrowDown
